import type {FC} from 'react';

import type {Props} from './types';

import {
  Container,
  getCalculatedStyles,
  Label,
  LogoIcon,
  LogoTextIcon,
  PwrContainer,
  PwrIcon,
} from './styles';

const Logo: FC<Props> = props => {
  const {label, size = 50, textColor, variant, ...rest} = props;

  const styles = getCalculatedStyles(size);

  return (
    <Container {...rest}>
      <LogoIcon style={styles.logo} />
      {variant === 'text' || variant === 'pwr' ? (
        <LogoTextIcon color={textColor} style={styles.text} />
      ) : null}
      {variant === 'pwr' ? (
        <PwrContainer>
          <PwrIcon style={styles.pwr} />
        </PwrContainer>
      ) : null}
      {label && variant ? <Label style={styles.label}>{label}</Label> : null}
    </Container>
  );
};

export {Logo};
